import { createContext, ReactNode, useState } from 'react';
import dynamic from 'next/dynamic';

const SizePreferencesModal = dynamic(
  () => import('sizePreferences/components/SizePreferencesModal'),
  { ssr: false },
);

interface ISizePreferencesModalProvider {
  children: ReactNode;
}

export const SizePreferencesModalContext = createContext(null);

export const SizePreferencesModalProvider = ({ children }: ISizePreferencesModalProvider) => {
  const [isSizePreferencesModalOpen, setIsSizePreferencesModalOpen] = useState<boolean>(false);
  const closeSizePreferencesModal = () => setIsSizePreferencesModalOpen(false);
  const openSizePreferencesModal = () => setIsSizePreferencesModalOpen(true);

  const values = {
    isSizePreferencesModalOpen,
    closeSizePreferencesModal,
    openSizePreferencesModal,
  };

  return (
    <SizePreferencesModalContext.Provider value={values}>
      {children}
      {isSizePreferencesModalOpen && <SizePreferencesModal onClose={closeSizePreferencesModal} />}
    </SizePreferencesModalContext.Provider>
  );
};
